export var DEFAULT_STANDARD_INTERVAL = 'daily';
export var DEFAULT_CUSTOM_INTERVAL = 'every_7_days';
export var STANDARD_TAB = 'standard';
export var CUSTOM_TAB = 'custom';